var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtFasTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3645_3538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8868 68.8614L90.9609 71.0312L94.0747 78.0999L99.0005 75.93L95.8868 68.8614Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.292 61.4596L98.3652 63.6289L101.478 70.6983L106.405 68.529L103.292 61.4596Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2499 108.46H51.0645V52.3164H84.2499V108.46ZM53.7559 105.768H81.5584V55.0078H53.7559V105.768Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5952 55.008H49.7184C48.2111 55.008 47 53.7699 47 52.2896V46.7184C47 45.2111 48.2111 44 49.7184 44H51.9253V46.6914H49.7184L49.6914 52.2896L85.5952 52.3165L85.6221 46.7184L55.0205 46.6914V44H85.5952C87.1024 44 88.3135 45.2111 88.3135 46.7184V52.2627C88.3135 53.7699 87.1024 55.008 85.5952 55.008Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0093 84.185H58.3308C56.7967 84.185 55.5586 82.9469 55.5586 81.4128V61.3347C55.5586 59.8006 56.7967 58.5625 58.3308 58.5625H77.0093C78.5435 58.5625 79.7815 59.8006 79.7815 61.3347V81.4128C79.7546 82.9469 78.5165 84.185 77.0093 84.185ZM58.3308 61.2539L58.25 81.4128L77.0093 81.4935C77.0632 81.4935 77.0901 81.4666 77.0901 81.4128V61.3347L58.3308 61.2539Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0093 104.074H58.3308C56.7967 104.074 55.5586 102.836 55.5586 101.302V90.4558C55.5586 88.9217 56.7967 87.6836 58.3308 87.6836H77.0093C78.5435 87.6836 79.7815 88.9217 79.7815 90.4558V101.302C79.7546 102.836 78.5165 104.074 77.0093 104.074ZM58.3308 90.375L58.25 101.302L77.0093 101.383C77.0632 101.383 77.0901 101.356 77.0901 101.302V90.4558L58.3308 90.375Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4088 108.461H81.5312V81.5738C81.5312 78.8554 83.7382 76.6484 86.4566 76.6484C89.1749 76.6484 91.3819 78.8554 91.3819 81.5738V97.9915H88.6905V81.5738C88.6905 80.3357 87.6946 79.3399 86.4566 79.3399C85.2185 79.3399 84.2227 80.3357 84.2227 81.5738V105.77H88.7174V101.921H91.4088V108.461Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0324 84.2101L89.1215 82.3261L107.8 63.2438C108.204 62.8401 108.446 62.2749 108.446 61.7097C108.446 61.1176 108.204 60.5255 107.746 60.0948C107.316 59.6642 106.777 59.4489 106.185 59.4489C105.593 59.4489 105.028 59.6911 104.597 60.1217L86.1609 78.9618L84.25 77.0778L102.686 58.2377C103.628 57.2957 104.866 56.7574 106.185 56.7574C107.531 56.7036 108.715 57.2688 109.657 58.1839C110.599 59.099 111.164 60.3909 111.164 61.7097C111.164 62.9747 110.653 64.2396 109.738 65.1278L91.0324 84.2101Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9999 84.1829H62.3418V80.6572C62.3418 77.7235 64.7372 75.3281 67.6708 75.3281C70.6045 75.3281 72.9999 77.7235 72.9999 80.6572V84.1829ZM65.0332 81.4915H70.3084V80.6572C70.3084 79.2038 69.1242 78.0196 67.6708 78.0196C66.2175 78.0196 65.0332 79.2038 65.0332 80.6572V81.4915Z",
    fill: "#09081A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3645_3538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.11,
    height: 64.4599,
    fill: "white",
    transform: "translate(47 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtFasTag);
export default __webpack_public_path__ + "static/media/FtFASTag.d1dd4ca4.svg";
export { ForwardRef as ReactComponent };